import React from "react"
import { Redirect, useLocation } from "react-router-dom"

const FUNNEL_PATH = "/consumer/payment"

/**
 * `/consumer` → `/consumer/payment` (CONAPP-485).
 *
 * The base path used to serve a temporary static distribution landing page (CONAPP-155), and behind
 * that the consumer package's placeholder home. Both are gone, and the subscription funnel is the
 * only thing a visitor arriving at `/consumer` should get, so the base path just forwards there.
 *
 * The query string and hash are carried over because react-router's string `to` drops them, and the
 * distribution links pointing at this path carry the campaign parameters the funnel's analytics
 * read — a redirect that dropped them would silently unattribute every signup that came through a
 * `/consumer?utm_source=…` link. Same pattern as {@link ./LegacyFunnelPathRedirect} and
 * `#/pages/consumer-subscription-billing/LegacyBillingPathRedirect`.
 *
 * Mounted in `Root` ABOVE the lazy `ConsumerRouter`, so the hop costs neither the consumer chunk nor
 * that router's program-guard round trip. `ConsumerRouter`'s own catch-all forwards here too, for
 * the unknown subpaths this exact route doesn't cover.
 */
export default function ConsumerRootRedirect(): JSX.Element {
  const { search, hash } = useLocation()
  return <Redirect to={{ pathname: FUNNEL_PATH, search, hash }} />
}
